import { faHdd } from "@fortawesome/free-regular-svg-icons/faHdd";
export let iconStorage = faHdd;
export function overwriteStorage(icon) {
    iconStorage = icon;
}
export default iconStorage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9zdG9yYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLE9BQU8sRUFBRSxLQUFLLEVBQUUsTUFBTSwyQ0FBMkMsQ0FBQztBQUVsRSxNQUFNLENBQUMsSUFBSSxXQUFXLEdBQUcsS0FBSyxDQUFDO0FBRS9CLE1BQU0sVUFBVSxnQkFBZ0IsQ0FBQyxJQUFvQjtJQUNuRCxXQUFXLEdBQUcsSUFBSSxDQUFDO0FBQ3JCLENBQUM7QUFFRCxlQUFlLFdBQVcsQ0FBQyJ9